/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SurveysWithRelations } from './surveysWithRelations';
import { QuestionEvaluationWithRelations } from './questionEvaluationWithRelations';


/**
 * (tsType: SurveyResponsesWithRelations, schemaOptions: { includeRelations: true })
 */
export interface SurveyResponsesWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    surveyId?: string;
    questionId?: string;
    score: number;
    scoreDisplay: number;
    includeInAverage?: boolean;
    surveys?: SurveysWithRelations;
    questionEvaluation?: QuestionEvaluationWithRelations;
}

